var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit315X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "64E59032-2F31-43C7-A07B-EFD47268B920@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,1.81066017 L1.5,9.31066017 L1.5,11.25 L3.43933983,11.25 L10.9393398,3.75 L9,1.81066017 Z M9.53033009,0.219669914 L12.5303301,3.21966991 C12.8232233,3.51256313 12.8232233,3.98743687 12.5303301,4.28033009 L4.28033009,12.5303301 C4.1396778,12.6709824 3.94891237,12.75 3.75,12.75 L0.75,12.75 C0.335786438,12.75 0,12.4142136 0,12 L0,9 C0,8.80108763 0.0790176303,8.6103222 0.219669914,8.46966991 L8.46966991,0.219669914 C8.76256313,-0.0732233047 9.23743687,-0.0732233047 9.53033009,0.219669914 Z M0.75,16.5 L14.25,16.5 C14.6642136,16.5 15,16.1642136 15,15.75 C15,15.3357864 14.6642136,15 14.25,15 L0.75,15 C0.335786438,15 0,15.3357864 0,15.75 C0,16.1642136 0.335786438,16.5 0.75,16.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_Abonnement",
    transform: "translate(-784.000000, -413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(104.000000, 386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-4",
    transform: "translate(387.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/align_justify-Copy-2",
    transform: "translate(273.500000, 4.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#162A41",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit315X);
export default __webpack_public_path__ + "static/media/edit_3@1,5x.bbdb883f8c9e1e70176357128108988e.svg";
export { ForwardRef as ReactComponent };